import { t } from "i18next";

import { Box, Typography } from "@mui/material";

import {
  heroTitleCardSx,
  heroTitleCardWrapperSx,
  heroTitleEmphasisSpanSx,
  heroTitleMainSpanSx,
  heroTitleTextSx
} from "@/src/pages/consumer/HomePage/components/HomePageHeader/homePageHeader.styles";
import { CONSUMER_HOMEPAGE_PREFIX } from "@/src/pages/consumer/HomePage/homePage.constants";

const HeroTitleCard = () => (
  <Box sx={heroTitleCardWrapperSx}>
    <Box sx={heroTitleCardSx}>
      <Typography component="h1" variant="h1" sx={heroTitleTextSx}>
        <Box component="span" sx={heroTitleMainSpanSx}>
          {t(`${CONSUMER_HOMEPAGE_PREFIX}.titleMain`)}
        </Box>
        <Box component="span" sx={heroTitleEmphasisSpanSx}>
          {t(`${CONSUMER_HOMEPAGE_PREFIX}.titleEmphasis`)}
        </Box>
      </Typography>
    </Box>
  </Box>
);

export default HeroTitleCard;
